import {HiOutlineLightBulb} from "react-icons/hi";
import {renderMarkdownContent} from "./utils";
import {Tag} from "../types";
import React from "react";

interface ThinkingSectionProps {
  stableKey: string;
  tag: Tag;
}

const ThinkingSection: React.FC<ThinkingSectionProps> = ({ stableKey, tag }) =>  {

  const contentWithoutFirstBold = React.useMemo(() => {
    if (!tag?.content) return '';
    try {
      return tag.content.replace(/\*\*[\s\S]*?\*\*/, '').trimStart();
    } catch (e) {
      return tag.content;
    }
  }, [tag?.content]);

  return (
    <div key={stableKey} className="thinking-section timeline-node">
      <div className="thinking-header">
        <div className="thinking-title w-full flex items-center justify-between">
          <div className="flex items-center gap-2">
            <HiOutlineLightBulb className="w-3 h-3" />
            <span>{tag.text || 'Thinking'}</span>
            {tag.isStreaming && (
              <div className="thinking-dots">
                <div className="thinking-dot" />
                <div className="thinking-dot" />
                <div className="thinking-dot" />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="thinking-content">
        {renderMarkdownContent(contentWithoutFirstBold, tag.isStreaming)}
        {tag.isStreaming && <span className="thinking-cursor" />}
      </div>
    </div>
  );
}

export default ThinkingSection;